import { ApiClient } from '@webapp/core/services/ApiClient'
import { CreditCardRepository } from './CreditCardRepository'

export const creditCardRepository = new CreditCardRepository({
  httpClient: ApiClient,
})

export { CreditCardRepository }
